
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcChartLineBase as ObcChartLineBaseElement} from '@oicl/openbridge-webcomponents/dist/building-blocks/chart-line/chart-line-base.js';
 
 
 

 
 export const ObcChartLineBase = createComponent({
   react: React,
   tagName: 'undefined',
   elementClass: ObcChartLineBaseElement,
   events: {
     
   }
  });
 
 